import { action } from 'satcheljs';

export default action('SELECT_CATEGORIES_OPTIONS');
